import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-light-svg-icons';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { BoldBodyText, Grid, SmallBodyText } from 'ui-toolkit';
import { DateTime } from 'luxon';
import { PrimaryHeader } from './styledComponents/PrimaryHeader';
import { DateFormat, getDateString } from '../../ui-toolkit/utilities/getDateString';

interface IDocumentInformation {
  documentName: string;
  uploadText?: string;
  uploadDateTime?: string;
}

export const DocumentInformation: React.FC<IDocumentInformation> = ({ documentName, uploadText, uploadDateTime }) => {
  const isDocumentUploaded = uploadDateTime && DateTime.fromISO(uploadDateTime).isValid;
  const dateTimeString = `${uploadText ? uploadText : 'Completed'} ${getDateString(
    DateFormat.hugeDateTime,
    uploadDateTime,
    true
  )}`;
  return (
    <Grid templateColumns={'min-content 1fr'} alignItems={'center'}>
      <PrimaryHeader>
        {isDocumentUploaded ? <FontAwesomeIcon icon={faCheckCircle} /> : <FontAwesomeIcon icon={faCircle} />}
      </PrimaryHeader>
      <div>
        <BoldBodyText>{documentName}</BoldBodyText>
        <SmallBodyText>{isDocumentUploaded && dateTimeString}</SmallBodyText>
      </div>
    </Grid>
  );
};
